import React, { useEffect, useState } from "react";
import "./summaryScreenLayout.css";

import NumberInCircle from "../../common/numberInCircle/numberInCircle";
import CustomRadioButton from "../../common/customRadioButton/customRadioButton";

import { useSharedState } from "../../context/formsContext";
import { getProperty } from "../../utils/apiResponseHelper";

const SummaryScreenLayout = ({
  questionNumber,
  explanation,
  questionId,
  curriculumId,
  questionText,
  questionImages,
  isPassed,
  questionAnsweredCorrectly,
  isGcse,
}) => {
  const { summary, testData, prefix } = useSharedState();

  const [selectedAnswers, setSelectedAnswers] = useState([]);
  const [testAnswers, setTestAnswers] = useState([]);
  const [correctAnswer, setCorrectAnswer] = useState([]);
  const [questionPassed, setQuestionPassed] = useState(false);

  useEffect(() => {
    const getData = async () => {
      await getTestAnswers();
      await getSelectedAnswers();
      await fetchCorrectAnswer();
    };
    getData();
  }, []);

  const handleCorrectQuestion = () => {
    if (questionAnsweredCorrectly === "Y") {
      return true;
    } else {
      return false;
    }
  };

  const fetchCorrectAnswer = async () => {
    const sessionLoginToken = localStorage.getItem("loginToken");

    try {
      const response = await fetch(
        `${prefix}/api-40/api40/Lesson/GetCorrectAnswer/${questionId}/1`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          Authorization: `Bearer ${sessionLoginToken}`,
          "X-API-Key": "8dnd6%3258%&k+_FsaTK25SCBNE58*t9"
        },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch test answers");
      }
      const data = await response.json();
      setCorrectAnswer(data);

      return { setTestAnswers: data };
    } catch (error) {
    }
  };

  const getTestAnswers = async () => {
    const sessionLoginToken = localStorage.getItem("loginToken");

    try {
      const response = await fetch(
        `${prefix}/api-40/api40/Lesson/GetLiveQuizAnswerOptions?QuestionId=${questionId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          Authorization: `Bearer ${sessionLoginToken}`,
          "X-API-Key": "8dnd6%3258%&k+_FsaTK25SCBNE58*t9"
        },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch test answers");
      }
      const data = await response.json();
      setTestAnswers(data);
      return { setTestAnswers: data };
    } catch (error) {
    }
  };

  const getSelectedAnswers = async () => {
    const sessionLoginToken = localStorage.getItem("loginToken");

    try {
      const response = await fetch(
        `${prefix}/api-40/api40/Lesson/GetSelectedAnswers?CurriculumId=${curriculumId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          Authorization: `Bearer ${sessionLoginToken}`,
          "X-API-Key": "8dnd6%3258%&k+_FsaTK25SCBNE58*t9"
        },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch selected test answers");
      }

      const data = await response.json();

      const fetchedAnswers = data.map((item) => {
        return getProperty(item, 'answers') || getProperty(item, 'Answers') || item?.Answers || item?.answers || '';
      }).filter(Boolean);

      setSelectedAnswers(fetchedAnswers);

      return { selectedAnswer: fetchedAnswers };
    } catch (error) {
    }
  };

  const checkQuestionPassed = () => {
    if (isPassed === "P") {
      setQuestionPassed(true);
    } else {
      setQuestionPassed(false);
    }
  };

  useEffect(() => {
    checkQuestionPassed();
  }, [isPassed]);

  const prefixImage = (questionText) => {
    if (!questionText) return "";
    return questionText.replace(
      /<img\s+[^>]*src="(\/backoffice[^"]*)"/g,
      '<img src="https://ksol.co.uk$1"'
    );
  };

  const prefixImageExplanation = (explanationText) => {
    if (!explanationText) return "";
    return explanationText.replace(
      /<img\s+[^>]*src="(\/graphics[^"]*)"/g,
      '<img src="https://ksol.co.uk$1"'
    );
  };

  return (
    <div className="col-start-2">
      <div className="  pt-2 col-start-1  row-start-2  flex justify-start w-full md:mt-0 md:justify-end md:hidden md:grid">
        <NumberInCircle
          color={isGcse ? "blue" : "orange"}
          number={questionNumber}
        />
      </div>
      <div className="hidden col-start-1 mt-4 row-start-3  flex justify-start w-full md:grid  ">
        <NumberInCircle
          color={isGcse ? "blue" : "orange"}
          number={questionNumber}
        />
      </div>
      <div className="py-4 col-start-2 col-span-12 row-start-3 md:py-4 md:p-0">
        <div
          className={`bg-white w-full h-auto ${
            isGcse ? "rounded-xl" : "rounded-3xl"
          } shadow-md pb-10`}
        >
          <h3 className="p-4 font-bold">Question</h3>
          <p
            className="p-4"
            dangerouslySetInnerHTML={{ __html: prefixImage(questionText) }}
          />

          {questionImages && (
            <img className="p-4" src={`https://ksol.co.uk/${questionImages}`} />
          )}
        </div>

        <div
          className={`bg-white w-full h-auto ${
            isGcse ? "rounded-xl" : "rounded-3xl"
          } shadow-md pb-8 mt-4`}
        >
          <div className="p-4 flex items-center">
            <h3 className=" font-bold">Answer</h3>
          </div>
          {questionPassed && (
            <div className=" ml-4 bg-amber-500 text-white p-2 rounded-lg w-auto inline-block">
              <p className="font-bold">Question Passed</p>
            </div>
          )}
          {handleCorrectQuestion(questionAnsweredCorrectly) && (
            <div className="ml-4 mr-4 mt-4 p-2 bg-lime-500 rounded-lg inline-block">
              <p className="font-bold text-white">
                Question Answered Correctly
              </p>
            </div>
          )}
          <div className="p-4 flex flex-col">
            {testAnswers.map((answer, index) => {
              const answerOptionId = getProperty(answer, 'answerOptionId') || getProperty(answer, 'AnswerOptionId') || answer?.AnswerOptionId || answer?.answerOptionId;
              const answerPresentation = getProperty(answer, 'answerPresentation') || getProperty(answer, 'AnswerPresentation') || answer?.AnswerPresentation || answer?.answerPresentation || '';
              
              // Get correct answer IDs using getProperty
              const correctAnswerIds = correctAnswer.map((correct) => {
                const correctAnswerId = getProperty(correct, 'correctAnswerId') || getProperty(correct, 'CorrectAnswerId') || correct?.CorrectAnswerId || correct?.correctAnswerId;
                return correctAnswerId?.toString();
              }).filter(Boolean);
              
              return (
                <div key={answerOptionId}>
                  <CustomRadioButton
                    isSummary={true}
                    answer={answerPresentation}
                    selectedAnswer={selectedAnswers}
                    correctAnswer={correctAnswer}
                    questionPassed={questionPassed}
                    questionAnsweredCorrectly={handleCorrectQuestion(
                      questionAnsweredCorrectly
                    )}
                    isSelected={selectedAnswers.includes(
                      answerOptionId?.toString()
                    )}
                    isCorrect={correctAnswerIds.includes(answerOptionId?.toString())}
                  />
                </div>
              );
            })}
          </div>
          <div className="ml-4 mr-4 mt-4 p-2 bg-lime-500 rounded-lg inline-block">
            <p
              className="font-bold  text-white "
              dangerouslySetInnerHTML={{
                __html: `Correct Answer:<br>${correctAnswer
                  .map((answer) => {
                    const correctAnswerString = getProperty(answer, 'correctAnswerString') || getProperty(answer, 'CorrectAnswerString') || answer?.CorrectAnswerString || answer?.correctAnswerString || '';
                    return correctAnswerString;
                  })
                  .filter(Boolean)
                  .join("<br>")}`,
              }}
            />
          </div>
        </div>
        <div
          className={`font-override font-override-two mb-4 bg-white grid mt-4 col-start-2 row-start-11 row-span-7 row-auto w-full ${
            isGcse ? "rounded-xl" : "rounded-3xl"
          } col-span-11 shadow-md md:mt-4 md:mb-0`}
        >
          <h3 className="p-4 font-bold">Explanation</h3>

          <p
            className="p-4 "
            dangerouslySetInnerHTML={{
              __html: prefixImageExplanation(explanation),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SummaryScreenLayout;
